// This function will add all scanned products to the cart
const addToCart = async (variantIds) => {
  try {
    // Map the variant IDs to the items array format for cart addition
    const items = variantIds.map((variantId) => ({
      id: variantId,
      quantity: 1,
    }));

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });

    if (response.ok) {
      // alert("Products added to cart!");
      // window.location.href = "/cart"; // Redirect to cart after adding
    } else {
      const errorText = await response.text();
      // alert(`商品をカートに追加できませんでした: ${errorText}`);
    }
  } catch (error) {
    console.error("Error adding to cart:", error);
  }
};

// Fetch product information based on the handle
const fetchProduct = async (productHandle) => {
  const response = await fetch(`/products/${productHandle}.js`);

  if (!response.ok)
    throw new Error("ネットワーク応答が正常ではありませんでした");

  const product = await response.json();
  return product;
};

let scannedResults = [];
let checkScannedResults = [];
let isProcessing = false;
let duplicateTimeouts = {};
let scanCount = {}; // Object to store scan counts for each product

// Function to create toast messages
const showToast = (message, type) => {
  const toast = document.createElement("div");
  toast.textContent = message;
  toast.classList.add("toast", type);

  // Append toast to body
  document.body.appendChild(toast);

  // Remove toast after a short delay
  setTimeout(() => {
    toast.remove();
  }, 3000);
};

// This function will handle the scanning logic
const onScanSuccess = async (decodedText, decodedResult) => {
  scannedResults = [decodedText];
  if (checkScannedResults.includes(decodedText)) {
    console.log(`Duplicate scan ignored: ${decodedText}`);

    if (!duplicateTimeouts[decodedText]) {
      duplicateTimeouts[decodedText] = setTimeout(() => {
        console.log(`Resuming scan for: ${decodedText}`);
        const index = checkScannedResults.indexOf(decodedText);
        if (index !== -1) {
          checkScannedResults.splice(index, 1);
        }
        delete duplicateTimeouts[decodedText];
      }, 3000);
    }
    return;
  }
  checkScannedResults.push(decodedText);
  // showToast(`QRコードのスキャンに成功しました。`, "success");
  // window.location.href = decodedText;
  // return;

  try {
    const url = new URL(decodedText);
    const productHandle = url.pathname.split('/products/')[1];
    const variantId = url.searchParams.get('variant');

    const product = await fetchProduct(productHandle);

    if (!product) {
      showToast(`商品が見つかりません: ${productHandle}`, "error");
      return;
    }

    if (!product.available) {
      console.log(`Product ${product.title} is out of stock.`);
      showToast(`${product.title} は在庫切れです。`, "warning");
      return;
    }

    // バリエーションの処理を改善
    if (variantId) {
      // バリエーションが指定されている場合
      const variant = product.variants.find(v => v.id.toString() === variantId);
      if (!variant) {
        showToast(`指定されたバリエーションが見つかりません: ${product.title}`, "error");
        return;
      }
      
      if (!variant.available) {
        showToast(`${product.title}のこのバリエーションは在庫切れです。`, "warning");
        return;
      }
      
      scanCount[decodedText] = (scanCount[decodedText] || 0) + 1;
      showToast(`商品 ${product.title} が正常にスキャンされました。`, "success");
      addToCart([variant.id]);
    } else {
      // バリエーションが指定されていない場合
      if (product.variants.length === 1) {
        // 単一バリエーションの場合
        const variant = product.variants[0];
        if (!variant.available) {
          showToast(`${product.title}は在庫切れです。`, "warning");
          return;
        }
        
        scanCount[decodedText] = (scanCount[decodedText] || 0) + 1;
        showToast(`商品 ${product.title} が正常にスキャンされました。`, "success");
        addToCart([variant.id]);
      } else {
        // 複数バリエーションがある場合
        showToast(`バリエーション情報が不足しています: ${product.title}`, "error");
        return;
      }
    }

  } catch (error) {
    console.error("Error:", error);
    showToast(`商品情報を取得できませんでした: ${productHandle}`, "error");
  }
};

// // Initialize the QR code scanner
// const html5QrcodeScanner = new Html5QrcodeScanner("reader", { fps: 10, qrbox: 200 });
// html5QrcodeScanner.render(onScanSuccess);

// const AUDIO = new Audio();
// AUDIO.autoplay = true;

// // Event listener for sound
// const soundElement = document.querySelector("#sound");
// if (soundElement) {
//     soundElement.addEventListener("click", () => {
//         beep();
//     });
// }

let html5QrcodeScanner = null;
const modal = document.getElementById("qrModal");

function openModal() {
  modal.style.display = "block";
  document.body.classList.add("modal-open");
  startScanner();
}

function closeModal() {
  modal.style.display = "none";
  document.body.classList.remove("modal-open");
  localStorage.removeItem("HTML5_QRCODE_DATA");
  if (html5QrcodeScanner) {
    html5QrcodeScanner.clear();
    html5QrcodeScanner = null;
  }
}

window.addEventListener("load", function () {
  localStorage.removeItem("HTML5_QRCODE_DATA");
});

function startScanner() {
  if (html5QrcodeScanner === null) {
    html5QrcodeScanner = new Html5QrcodeScanner("reader", {
      fps: 5,
      qrbox: 250,
    });
    html5QrcodeScanner.render(onScanSuccess, onScanError);
  }
}

function onScanError(error) {
  console.warn(`Error Scan QR: ${error}`);
}

document.addEventListener("click", (event) => {
  if (event.target.id == "html5-qrcode-button-camera-stop") {
        if (Object.keys(scanCount).length === 0) {
            return;
        }
    window.location.href = "/cart";
  }
});